import { useCallback } from "react";
import { useFormikContext } from "formik";
import { TaskCreate } from "@common/contracts/task.contract";
import { EntityFilterCombobox } from "@components/entity/EntityFilter/EntityFilterCombobox";
import { EntityFilterType } from "@components/entity/EntityFilter/types";

export const TaskCreationEntityFilter = () => {
    const { values, setFieldValue } = useFormikContext<TaskCreate>();

    const handleChange = useCallback(
        ({ entityIds }: EntityFilterType) =>
            void setFieldValue("entityIds", entityIds ?? []),
        [setFieldValue],
    );

    return (
        <EntityFilterCombobox
            filters={{ entityIds: values.entityIds ?? [] }}
            onChange={handleChange}
            mode="selection"
        />
    );
};
